import {OnlyBinaryHeaderArg} from "@psdk/frame-father";

export class CSN extends OnlyBinaryHeaderArg<CSN> {

  constructor() {
    super();
  }

  header(): Uint8Array {
    return new Uint8Array([0x10, 0xff, 0xef, 0xf2]);
  }

  newline(): boolean {
    return false;
  }

}



